import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import classNames from 'classnames';

require('npm-zepto');

import { Logout } from '@dbk/com.db.dbk.ui-icons';
import DbText from '../../../assets/svgs/db-text.js';

class AppRMAdmin extends Component {
  constructor(props) {
    super(props);
  }

  handleLogoutPress = async () => {
    const { docupload: { winUserId }, auth: { setUserId } } = this.props;

    if (winUserId) {
      await setUserId(winUserId);
    }
    this.props.rmLogout();
  };


  WebNav() {
    const {
      i18n: { messages }

    } = this.props;


    return (

      <div className='nav-content-web'>
        <DbText className={'logo-web'} />
        <div className={"show-for-large"}>
          <a className={'nav-text-margin'}>
            <div className={classNames({ label: true })} >
              {messages['app.common.rm.welcomeAdmin']}
            </div>
          </a>
        </div>
        <div className="nav-icon-group-admin">
          <span
            className={'margin-left-20 margin-right-20 pointer logoutPopup'}
            onClick={this.handleLogoutPress}
          >
            <Logout width={24} height={24} color="#999" />
          </span>
        </div>
      </div >
    );

  }

  render() {
    return (
      <section className={'app-nav'}>
        <div className={'side-menu'}>
          {this.WebNav()}
        </div>
      </section>
    );
  }
}

export default createContainer({
  $queries: {
    rmLogout: { $call: 'rmAccess.logout' },
    i18n: {
      messages: true,
    },
    marque: {
      loginDissmiss: true,
    },
    docupload: {
      winUserId: true
    },
    auth: {
      setUserId: { $set: 'userId' }
    },
    ui: {
      history: {
        currentLocation: {
          pathname: true,
        },
      },
    },
  },
})(AppRMAdmin);


